export type IISError = {
    error: string;
    error_description: string;
};
export type TBIDVals = {
    timeSetAt: number;
    userInfo: { [k: string]: any };
};
export type TBIDProfile = {
    company: string;
    id: string;
    newRegistration: string;
    orgID: string;
    relationship: string;
    role: string;
};
export type ValidationError = {
    field: string;
    message: string;
};
export type ValidationErrorResponse = {
    errors: ValidationError[];
};
export type ProfileData = {
    [key: string]: any;
};

export type UserFieldsCDNSchema = {
    type: string;
    properties: any;
    required: Array<string>;
    additionalProperties?: boolean;
};

export type ProfileFieldsCDNSchema = {
    userFields: UserFieldsCDNSchema;
};

export type UpdateUserProfileRequest = {
    email?: string;
    firstName?: string;
    lastName?: string;
    role?: string;
    title?: string;
    relationshipToSalesforce?: string;
    pronoun?: string;
    username?: string;
    bio?: string;
    twitterHandle?: string;
    facebookHandle?: string;
    linkedinHandle?: string;
    websiteUrl?: string;
    workEmail?: string;
    phone?: {
        work?: string;
        mobile?: string;
        default?: string;
    };
    notifications?: {
        smsOptIn?: boolean;
        email?: string;
        ideaExchange?: {
            repliesEmailAlert?: boolean;
        };
        knownIssues?: {
            statusWorkingAsExpected?: boolean;
            statusSolutionReleased?: boolean;
            statusReleaseInProgress?: boolean;
            statusInProgress?: boolean;
            statusReadyForRelease?: boolean;
            statusNoLongerAssigned?: boolean;
        };
    };
    privacyDisclosure?: {
        id?: string;
        consentStatus?: boolean;
        acceptedDateTime?: string;
    };
    termsOfUseId?: string;
    company?: {
        name?: string;
        size?: string;
        website?: string;
    };
    address?: {
        street?: string;
        city?: string;
        state?: string;
        country?: string;
        zip?: string;
    };
    isPublicProfile?: boolean;
    isAvailableForHire?: boolean;
    language?: string;
};
export type LoginRequestV2 = {
    tbidConfigId: string;
    id_token: string;
    access_token: string;
    tbidConfigVersion?: string;
    client_id?: string;
};
export enum RequestParams {
    ID_TOKEN = 'id_token',
    ACCESS_TOKEN = 'access_token',
    TBID_CONFIG_ID = 'tbidConfigId',
    TBID_CONFIG_VERSION = 'tbidConfigVersion',
    CLIENT_ID = 'client_id',
}
export enum PolicyViolation {
    First_Time_User_Confirmation = 'First_Time_User_Confirmation',
    Employee_Email = 'Employee_Email',
    GovEmail = 'GovEmail',
    Profile_Incomplete = 'Profile_Incomplete',
}

export enum TBIDConfigOfferTypes {
    RAINFOCUS = 'rainfocus',
    EVENT_REGISTRATION = 'event-registration',
}
